export const FETCH_LICENSE_GENERATION_SETTINGS_REQUEST =
  'licenseGenerationSettings/FETCH_LICENSE_GENERATION_SETTINGS_REQUEST'
export const FETCH_LICENSE_GENERATION_SETTINGS_SUCCESS =
  'licenseGenerationSettings/FETCH_LICENSE_GENERATION_SETTINGS_SUCCESS'
export const FETCH_LICENSE_GENERATION_SETTINGS_FAILURE =
  'licenseGenerationSettings/FETCH_LICENSE_GENERATION_SETTINGS_FAILURE'

export const UPDATE_LICENSE_GENERATION_SETTINGS_REQUEST =
  'licenseGenerationSettings/UPDATE_LICENSE_GENERATION_SETTINGS_REQUEST'
export const UPDATE_LICENSE_GENERATION_SETTINGS_SUCCESS =
  'licenseGenerationSettings/UPDATE_LICENSE_GENERATION_SETTINGS_SUCCESS'
export const UPDATE_LICENSE_GENERATION_SETTINGS_FAILURE =
  'licenseGenerationSettings/UPDATE_LICENSE_GENERATION_SETTINGS_FAILURE'

export const UPDATE_FIELD = 'licenseGenerationSettings/UPDATE_FIELD'
export const SET_DEFAULT_DATA = 'licenseGenerationSettings/SET_DEFAULT_DATA'
